// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        authorizations: yup.array().of(yup.string())
    });

export default validationSchema;
